import { useEffect, useRef } from 'react';
import { CATEGORY_DATA_MARK } from '../../../constants/categoryDataMark';

type THandler = (category: string) => void;

export function useUpdateCategoryOnUserScroll(handler: THandler) {
  const isScrolledOnceRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (!isScrolledOnceRef.current) {
          return;
        }

        for (const entry of entries) {
          if (entry.isIntersecting) {
            handler(entry.target.id);
            break;
          }
        }
      },
      { rootMargin: '-50% 0px' },
    );

    const categoryNodes = document.querySelectorAll(`[${CATEGORY_DATA_MARK}]`);

    categoryNodes.forEach(node => observer.observe(node));

    return () => observer.disconnect();
  }, [handler]);

  useEffect(() => {
    document.addEventListener(
      'scroll',
      () => {
        isScrolledOnceRef.current = true;
      },
      { once: true },
    );
  }, []);
}
